export const ASO_ROCK_STORY_VIMEO_ID = "281506947";

const IMMERSIVE_VIMEO_QUERY = new URLSearchParams({
  background: "1",
  autopause: "0",
  loop: "1",
  autoplay: "1",
  muted: "1",
  controls: "0",
  title: "0",
  byline: "0",
  portrait: "0",
  badge: "0",
});

export function buildImmersiveVimeoEmbedUrl(videoId: string) {
  return `https://player.vimeo.com/video/${videoId}?${IMMERSIVE_VIMEO_QUERY.toString()}`;
}

export const ASO_ROCK_STORY_VIMEO_EMBED_URL =
  buildImmersiveVimeoEmbedUrl(ASO_ROCK_STORY_VIMEO_ID);
